import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatemobilitysolutioninpune() {



  const cardData =
  {
    keyword: ' Corporate Mobility Solutions in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Mobility Solutions in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides comprehensive Corporate Mobility Solutions in Pune, supporting the transportation needs of IT parks, industrial zones, corporate offices, business centers, and commercial hubs across the city. Our modern fleet of sedans, SUVs, MUVs, luxury cars, and employee transport vehicles ensures safe, comfortable, and timely travel for staff, managers, business delegates, and top executives. Whether it is daily employee commute, shift-based transport, airport transfers, inter-city business travel, client visits, industrial tours, or VIP movement, we deliver seamless and hassle-free mobility management. With trained chauffeurs, GPS-enabled vehicles, automated scheduling, flexible rental plans, and 24×7 service support, Pune Corporate Cars India Private Limited ensures efficient, reliable, and premium corporate travel solutions tailored to the requirements of businesses operating in Pune.',

    top: 'Top Places to Visit in Markal with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Mahatma Phule Wada, Markal",
    "description": "Mahatma Phule Wada in Markal is an important cultural landmark that honors the legacy of social reformer Jyotirao Phule. Surrounded by rural landscapes and traditional settlement patterns, the site reflects early social development movements in the region. Visitors can explore the surroundings, local community activities, and rural craftsmanship that represent the lifestyle and society that existed during Phule’s time. The peaceful ambiance and historical connection make it a meaningful stop for those interested in social history and Maharashtra’s reformist movement."
  },
  {
    "title": "Markal Ganesh Temple",
    "description": "Markal Ganesh Temple is a popular spiritual landmark in the village, dedicated to Lord Ganesha. The temple is frequently visited by locals and surrounding villages for daily prayers, religious ceremonies, and community gatherings. Festivals like Ganesh Chaturthi transform the temple into a vibrant hub of devotional music, artistic decorations, and traditional celebrations. The temple’s calm rural setting, combined with its spiritual significance, makes it a serene place to relax, reflect, and experience village devotion."
  },
  {
    "title": "Indrayani River Banks",
    "description": "Markal is located along the scenic stretch of the Indrayani River, providing beautiful natural landscapes ideal for quiet walks, riverside seating, birdwatching, photography, and refreshing mornings. During monsoon, the surroundings become lush and green, creating a tranquil setting perfect for nature lovers. Locals often visit the riverbank for festivals, daily relaxation, or peaceful evening views, offering a simple yet soothing connection with nature and rural charm."
  },
  {
    "title": "Alandi (Nearby Pilgrimage Town)",
    "description": "Just a short drive from Markal, Alandi is one of Maharashtra’s most significant pilgrimage destinations and the spiritual home of Sant Dnyaneshwar. The Dnyaneshwar Samadhi Temple, located on the banks of the Indrayani River, attracts devotees from across India. The town becomes especially vibrant during the annual Pandharpur Wari, when thousands of pilgrims (Warkaris) travel on foot in devotional unity. Walking through Alandi offers a deep cultural experience of spiritual traditions, temple bells, river rituals, devotional singing, and centuries-old Marathi saint literature."
  },
  {
    "title": "Dehu (Birthplace of Sant Tukaram)",
    "description": "Dehu, located close to Markal, is the birthplace of the revered Marathi saint–poet Sant Tukaram. The town is home to the famous Tukaram Maharaj Temple, which sits on the peaceful banks of the Indrayani River. Pilgrims visit throughout the year to attend kirtans, devotional music, spiritual gatherings, and celebrations that honor the legacy of Tukaram’s abhangas (devotional poetry). Dehu forms a holy twin-town circuit with Alandi and offers a rich glimpse into the soul of Maharashtra’s Bhakti tradition."
  },
  {
    "title": "Dighi Hills Viewpoint (Nearby Natural Spot)",
    "description": "The hills near Dighi, not far from Markal, offer a quiet scenic spot for short hikes, nature photography, and open countryside views. During winter and monsoon seasons, the area becomes lush with greenery and misty hillsides. The calm outdoors makes it a great getaway for families or solo travelers looking to experience natural landscapes without traveling far from Pune and surrounding towns."
  },
  {
    "title": "Kadamwak Wasti Biodiversity Surroundings (Nearby)",
    "description": "Kadamwak Wasti, close to Markal, is surrounded by agricultural fields, canal irrigation networks, and bird-friendly green zones. The region provides an authentic countryside environment where visitors can observe traditional farming, seasonal crops, local lifestyle, and occasional migratory birds. It is especially appealing for students, nature lovers, and photographers who want to capture real rural Maharashtra without commercialization."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Accessible Day Trip)",
    "description": "Located within reach for a day trip from Markal, the Rajiv Gandhi Zoological Park in Pune is one of Maharashtra’s major wildlife attractions, featuring a zoo, animal rescue center, botanical surroundings, and the Katraj Lake. The park houses tigers, crocodiles, birds, reptiles, herbivores, and educational exhibits that provide learning experiences for children and visitors. The calm and green environment makes it a refreshing outing that blends nature, awareness, and recreation."
  }
],


"services": [
{
"name": "Markal Employee Shuttle",
"description": "Markal Employee Shuttle provides comprehensive bulk transportation for employees working in Markal MIDC. The service utilizes shuttle vans and minibuses with structured routes and multi-shift scheduling to ensure punctual, safe, and comfortable commutes. It helps companies streamline workforce mobility, reduce logistical challenges, and guarantee timely arrival for employees across factories, offices, and industrial units."
},
{
"name": "Industrial Worker Cab Markal",
"description": "Industrial Worker Cab Markal specializes in safe and reliable transport for industrial workers in Markal. The service offers dedicated vehicles for shift-based commuting, GPS-enabled tracking, trained drivers, and adherence to safety protocols. It ensures timely pickups and drops, minimizes employee commute stress, and provides organized travel solutions for manufacturing and factory operations."
},
{
"name": "Staff Pickup Drop Markal",
"description": "Staff Pickup Drop Markal delivers structured and secure daily commute solutions for corporate and factory staff. With planned routes, trained drivers, and well-maintained vehicles, it guarantees smooth transportation for employees, reduces travel-related delays, and enhances overall productivity by ensuring employees reach workplaces on time."
},
{
"name": "Corporate Fleet Markal MIDC",
"description": "Corporate Fleet Markal MIDC provides businesses with a dedicated fleet of sedans, SUVs, and staff cabs to handle daily employee commuting and corporate travel. The service focuses on operational efficiency, reliability, and comfort, supporting multi-shift schedules, inter-office travel, and client visits, while ensuring vehicles are professionally managed and always available when needed."
},
{
"name": "Business Travel Cab Markal",
"description": "Business Travel Cab Markal offers professional transportation for corporate meetings, client visits, and business trips. Equipped with well-maintained sedans and SUVs, the service prioritizes punctuality, safety, and comfort. It caters to executives, managers, and visiting clients, providing hassle-free bookings, professional drivers, and flexible routes for all corporate travel needs."
},
{
"name": "Affordable Cab Service Markal",
"description": "Affordable Cab Service Markal delivers budget-friendly commuting solutions for employees and corporate staff in Markal. The service balances cost-effectiveness with reliability, offering clean, well-maintained vehicles, trained drivers, and consistent scheduling. It is ideal for small to medium-sized companies seeking economical yet dependable transportation for staff."
},
{
"name": "Best Corporate Cab Markal",
"description": "Best Corporate Cab Markal provides premium corporate transportation services, focusing on comfort, punctuality, and professional service. The fleet includes luxury sedans and SUVs with experienced drivers, catering to executives, managers, and corporate visitors. The service ensures high standards of safety, cleanliness, and convenience for all business travel requirements."
},
{
"name": "Monthly Cab Hire Markal",
"description": "Monthly Cab Hire Markal offers long-term rental solutions for companies requiring consistent employee transportation. The service provides dedicated vehicles, fixed monthly plans, and reliable daily operations. It supports multi-shift schedules, reduces administrative workload, and ensures uninterrupted staff commute, making it suitable for factories, offices, and industrial units."
},
{
"name": "Outstation Cab Markal MIDC",
"description": "Outstation Cab Markal MIDC provides safe and comfortable long-distance travel for corporate trips, factory visits, client meetings, and intercity business travel. The service ensures timely departures, professional drivers, and well-maintained vehicles, offering a stress-free and reliable experience for companies and employees traveling outside Markal."
},
{
"name": "Sedan Cab Markal",
"description": "Sedan Cab Markal delivers premium sedan vehicles for executives, managers, and corporate visitors. The service emphasizes comfort, punctuality, and professional driving, making it ideal for office travel, client meetings, and corporate events in Markal and nearby areas."
},
{
"name": "SUV Cab Markal",
"description": "SUV Cab Markal provides spacious and powerful SUVs suitable for group travel, industrial visits, and long-distance corporate commutes. The service ensures comfort, reliability, and safety for teams, executives, and staff requiring larger vehicles for daily or long-distance travel."
},
{
"name": "Worker Transport Markal MIDC",
"description": "Worker Transport Markal MIDC specializes in transporting factory and industrial workers with structured routes and shift-based scheduling. The service ensures timely pickups and drops, safe travel practices, and well-maintained vehicles, making it an efficient solution for workforce mobility in large industrial units."
},
{
"name": "Company Cab Markal",
"description": "Company Cab Markal offers professional corporate cab services for employees, managers, and visitors. With trained drivers, GPS-enabled vehicles, and flexible scheduling, the service ensures smooth commuting for businesses, supporting both daily office travel and corporate events efficiently."
},
{
"name": "Employee Commute Markal",
"description": "Employee Commute Markal provides reliable daily commuting solutions for office and factory staff. The service focuses on punctuality, safety, and comfort, offering well-maintained vehicles, trained drivers, and organized routing to ensure stress-free travel for employees across Markal MIDC and surrounding areas."
},
{
"name": "Industrial Shuttle Markal",
"description": "Industrial Shuttle Markal delivers large-scale shuttle services for industrial staff and factory workers. Equipped with minibuses and vans, the service supports multi-shift operations, GPS tracking, safety protocols, and structured routes, ensuring reliable, safe, and comfortable transportation for the workforce."
}
],

"tableData": [
["Markal Employee Shuttle", "Industrial Worker Cab Markal"],
["Staff Pickup Drop Markal", "Corporate Fleet Markal MIDC"],
["Business Travel Cab Markal", "Affordable Cab Service Markal"],
["Best Corporate Cab Markal", "Monthly Cab Hire Markal"],
["Outstation Cab Markal MIDC", "Sedan Cab Markal"],
["SUV Cab Markal", "Worker Transport Markal MIDC"],
["Company Cab Markal", "Employee Commute Markal"],
["Industrial Shuttle Markal", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Markal MIDC Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable cab services for employees and executives commuting to Markal MIDC Pune, ensuring punctual and hassle-free corporate travel."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping corporate staff reach their offices and industrial hubs in Markal MIDC efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure journey for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet of Vehicles",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, well-serviced, and designed for safe and comfortable commuting."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Plans",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Markal MIDC Pune."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for scheduling, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and clean rides for employees and executives."
  },
  {
    "WhyChooseheading": "Easy Booking & Efficient Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our smooth booking process and reliable coordination, making employee transport stress-free."
  }
]
































  }

const faqData = [
  {
    question: 'Do you provide cab services in Markal MIDC Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dependable and well-managed cab services for companies and industries in Markal MIDC Pune.',
  },
  {
    question: 'What types of cab services are available in Markal MIDC?',
    answer: 'We offer employee transportation, corporate pickups and drops, shift-based cabs, and dedicated fleet services for Markal MIDC companies.',
  },
  {
    question: 'Do you provide daily pickup and drop services for employees in Markal MIDC?',
    answer: 'Yes, we provide daily employee transportation with optimized routes and on-time performance.',
  },
  {
    question: 'How can companies book cab services for Markal MIDC Pune?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for cab services in Markal MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and mini-buses depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term transportation contracts for Markal MIDC?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual transportation contracts for corporate clients.',
  },
  {
    question: 'Are safety features available in Markal MIDC cab services?',
    answer: 'All our vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs.',
  },
  {
    question: 'Do you support multi-shift employee transportation?',
    answer: 'Yes, we offer cab scheduling for morning, evening, night, and rotational shifts.',
  },
  {
    question: 'What payment options are available for cab services in Markal MIDC Pune?',
    answer: 'We support UPI, credit/debit cards, digital wallets, bank transfers, and monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Bansode',
    feedback: 'Great cab service in Markal MIDC. The drivers are punctual and the service is very well coordinated.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Thombre',
    feedback: 'Very reliable transportation service for our employees. Smooth operations and excellent support.',
    rating: 5,
  },
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Mobility Solutions in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-mobility-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers comprehensive corporate mobility solutions in Pune, including employee transport management, staff shuttles, office commute automation, business fleet solutions, and corporate vehicle management. Ensure efficient, safe, and timely travel for employees with our smart mobility services.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4600", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-mobility-solutions-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Mobility Solutions in Pune | Employee & Business Fleet Management | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers comprehensive corporate mobility solutions in Pune, including employee transport management, staff shuttles, office commute automation, business fleet solutions, and corporate vehicle management. Ensure efficient, safe, and timely travel for employees with our smart mobility services."
  />

  <meta
    name="keywords"
    content="Employee Transport Management Pune, Mobility as a Service Corporate Pune, Staff Shuttle Solutions Pune, Office Commute Automation Pune, Business Fleet Solutions Pune, Corporate Vehicle Management Pune, Employee Mobility Platforms Pune, Corporate Transport Planning Pune, Best Mobility Provider Pune, Workforce Commute Pune, Smart Office Travel Pune, Mobility Optimization Pune, Cab Management System Pune, Corporate Fleet Outsourcing Pune, Staff Mobility Partner Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatemobilitysolutioninpune;